import React, { useState } from "react";
import { overrideTailwindClasses } from "tailwind-override";

// Define the type for a single tab
export type Tab = {
  id: string;
  label: React.ReactNode;
  labelClassName?: string;
  content: React.ReactNode;
  contentClassName?: string;
  additionalCallback?: () => void;
};

// Define the props for the Tabs component
export type TabsProps = {
  tabs: Tab[];
  activeTabId?: string;
  className?: string;
  dataTestId?: string;
};

const Tabs = ({ tabs, activeTabId, className = "", dataTestId }: TabsProps) => {
  const [activeTab, setActiveTab] = useState<string>(activeTabId || tabs[0]?.id || "");

  return (
    <div className={className} data-test-id={dataTestId}>
      <div className="flex bg-offWhite overflow-y-hidden">
        {tabs.map(tab => (
          <button
            key={tab.id}
            type="button"
            onClick={() => {
              tab.additionalCallback?.();
              setActiveTab(tab.id);
            }}
            className={overrideTailwindClasses(
              `py-3 px-4 text-darkGray flex-1 ${
                activeTab === tab.id
                  ? "bg-white text-onyx rounded-tl-lg rounded-tr-lg border border-b-0 border-lighterGray shadow-lg"
                  : ""
              }`
            )}>
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab content */}
      <div className="border border-t-0 border-lighterGray">
        {tabs.map(
          tab =>
            tab.id === activeTab && (
              <div key={tab.id} className={`px-8 py-6 bg-white rounded ${tab.contentClassName || ""}`}>
                {tab.content}
              </div>
            )
        )}
      </div>
    </div>
  );
};

export default Tabs;
